import { getToken, deleteToken } from "firebase/messaging";
import { messaging } from "./firebase";
import Request from "../utils/Request";
import { api_version } from "../settings";

export const generateFCMToken = async () => {
    try {

        if (
            typeof window === 'undefined' ||
            !('Notification' in window) ||
            !('serviceWorker' in navigator)
        ) {
            return null;
        }

        const existingToken = localStorage.getItem('fcm_token');

        if (existingToken) {
            return existingToken;
        }

        if (Notification.permission === 'denied') {
            return null;
        }

        const permission = await Notification.requestPermission();

        if (permission !== 'granted') {
            return null;
        }

        const registration = await navigator.serviceWorker.register(
            '/firebase-messaging-sw.js'
        );

        const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration
        });

        if (!token) {
            return null;
        }

        await saveFCMToken(api_version, token);

        return token;

    } catch (error) {

        return null;
    }
};

export const saveFCMToken = async (api_version, token) => {

    try {

        if (!token) return;
        
        await Request.post(`${api_version}/save-fcm-token`, {
            fcm_token: token,
            device_type: "web",
            browser: navigator.userAgent,
            platform: navigator.userAgentData?.platform || "unknown"
        });

        localStorage.setItem("fcm_token", token);

    } catch (error) {

        console.log("SAVE FCM ERROR:", error);
    }
};

export const removeFCMToken = async () => {
    try {
        const token = localStorage.getItem("fcm_token");

        if (token) {
            await Request.post(`${api_version}/delete-fcm-token`, {
                fcm_token: token
            });
        }

        await deleteToken(messaging);

        localStorage.removeItem("fcm_token");

    } catch (error) {
        console.log("REMOVE FCM ERROR:", error);
    }
};